import { Button } from "@mui/material";
import { useCallback, useEffect, useRef, useState } from "react";

type Props = {
  onResend: () => Promise<void>;
};

const RESEND_DELAY = 60; // seconds

export const ResendFactor = (props: Props) => {
  const { onResend } = props;
  const [timeLeft, setTimeLeft] = useState(RESEND_DELAY);
  const [timerIsActive, setTimerIsActive] = useState(true);
  const timer = useRef<any>(null);

  useEffect(() => {
    if (timer.current) {
      clearTimeout(timer.current);
    }
    setTimeLeft(RESEND_DELAY);
  }, [onResend]);

  useEffect(() => {
    if (!timerIsActive) {
      return;
    }
    timer.current = setTimeout(() => {
      setTimeLeft(timeLeft - 1);
      if (timeLeft <= 1) {
        setTimerIsActive(false);
      }
    }, 1000);
    return () => clearTimeout(timer.current);
  }, [timeLeft, setTimeLeft, timerIsActive, setTimerIsActive]);

  const resend = useCallback(async () => {
    try {
      await onResend();
      setTimeLeft(RESEND_DELAY);
      setTimerIsActive(true);
    } catch (e) {
      // TODO: error handling
      console.error(e);
    }
  }, [onResend, setTimeLeft, setTimerIsActive]);

  return (
    <Button type='button' disabled={timeLeft > 0} onClick={resend} fullWidth>
      Resend code {timeLeft > 0 && `${timeLeft} sec`}
    </Button>
  );
};
